<template>
  <div class="permissions-popup border-0 p-1 bg-white rounded">
    <div class="d-flex flex-column">
      <div
        class="d-flex align-items-center cursor-pointer text-secondary pr-1"
        @click.stop="$emit('close')"
      >
        <GjIcon
          name="ArrowLeft"
          size="20"
        />
        <span class="title">Permissions</span>
      </div>
      <template v-if="!loading">
        <template v-if="!error">
          <div class="d-flex mt-1 border-default border-t pt-1">
            <b-form-radio-group
              id="permissions"
              v-model="isPublic"
              :options="options"
              name="permissions"
            />
          </div>
          <b-button
            variant="primary"
            class="mt-1"
            :disabled="settingPermission"
            @click="setPermission"
          >
            Save
          </b-button>
        </template>
        <div v-else>
          Error getting permissions.
        </div>
      </template>
      <div
        v-else
        class="text-center p-2"
      >
        <b-spinner />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Permissions',
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    eventType: {
      type: Number,
      default: 5,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isPublic: false,
      options: [
        { text: 'Public', value: true },
        { text: 'Private', value: false },
      ],
      settingPermission: false,
    }
  },
  computed: {
    bucketName() {
      return this.$route.params.id
    },
  },
  watch: {
    loading() {
      this.initForm()
    },
  },
  created() {
    this.initForm()
  },
  methods: {
    close() {
      this.$emit('closeCompletely')
    },
    initForm() {
      if (this.object) {
        this.isPublic = this.object.isPublic
      }
    },
    setPermission() {
      this.settingPermission = true
      this.$store
        .dispatch('accountObjects/updateObject', {
          accountId: this.accountId,
          query: {
            bucketName: this.bucketName,
            ...this.object,
            isPublic: this.isPublic,
          },
        })
        .then(() => {
          this.successToast('Permission updated successfully.')
          this.settingPermission = false
          this.$emit('updated', { isPublic: this.isPublic })
          this.close()
        })
        .catch(() => {
          this.errorToast('Error updating permission.')
          this.settingPermission = false
          this.isPublic = this.object.isPublic
          this.close()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.permissions-popup {
  .title {
    margin-left: 10px;
  }
  &::v-deep {
    .custom-radio {
      margin-bottom: 7px;
    }
  }
}
</style>
